import type { KnowledgeSearchArgs } from './knowledgeTypes';

/**
 * TanStack Query key factory for the knowledge surface.
 *
 * Centralizes the key shapes so callers and tests cannot drift. The search
 * key embeds the full args tuple (kinds sorted for stability) so two
 * components asking for the same filters share one cache entry.
 */
export const knowledgeKeys = {
  all: ['knowledge'] as const,
  search: (args: KnowledgeSearchArgs) =>
    [
      ...knowledgeKeys.all,
      'search',
      args.q.trim(),
      [...(args.kinds ?? [])].sort().join(','),
      args.activeDataset ?? '',
      args.sessionId ?? '',
      args.limit ?? null,
      args.minScore ?? null,
    ] as const,
  entry: (entryId: string) => [...knowledgeKeys.all, 'entry', entryId] as const,
  filterOptions: () => [...knowledgeKeys.all, 'filter-options'] as const,
};
